import Button from "../../uiComponents/Button";
import btnImg from "../../../static/images/btn_img.svg";
import { useDispatch } from "react-redux";
import { signInAtcion } from "../../../store/actions/user";
import "./SignIn.scss";

const SignIn = () => {
  const dispatch = useDispatch();
  const handleCLick = () => {
    dispatch(signInAtcion());
  };
  return (
    <div className="sing-in">
      <div className="form">
        <h1>
          Welcome
        </h1>
        <h3>
          <b>To start:</b> connect to your Autodesk account<br />
          <b>Then:</b> sign in to BIMSearch
        </h3>
        <Button
          clickFunction={handleCLick}
          transparent
        >
          Sign In with
          <img
            src={btnImg}
            alt="Autodesk"
          />
        </Button>
        <h3 className="first-time-user">
          First-time user? Read our <a className="sign-up-guide" href="https://bim-search.com/sign-up-guide/" target="_blank">sign-up guide</a>
        </h3>
      </div>
    </div>
  );
};

export default SignIn;
